module.exports = __webpack_public_path__ + "static/dog-1-alt-8c0285f98d834bc1c02df794dbcfa498.png";